import { css } from "@emotion/css";

import { white } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createDialogStyles = ({
  spacing,
  typography,
  boxShadows,
  zIndexes,
  backdrops,
  palette,
}: Theme) => ({
  overlay: css({
    position: "fixed",
    backgroundColor: backdrops.default,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: zIndexes.backdrop,
  }),
  dialog: css({
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: white,
    width: "95%",
    maxWidth: "366px",
    borderRadius: 5,
    paddingTop: spacing(3.5),
    boxShadow: boxShadows.modal,
    zIndex: zIndexes.dialog,
  }),
  dialogHeaderWrapper: css({
    padding: spacing([0, 4]),
  }),
  title: css({
    margin: spacing([0, 0, 2, 0]),
    padding: 0,
    color: palette.default.text,
    fontWeight: typography.fontWeight.semiBold,
  }),
  text: css({
    fontSize: typography.pxToRem(13),
    marginBottom: spacing(2),
    lineHeight: 1.4,
  }),
});
